import { render, staticRenderFns } from "./wx-mixed.vue?vue&type=template&id=09f29d59&scoped=true&"
import script from "./wx-mixed.vue?vue&type=script&lang=js&"
export * from "./wx-mixed.vue?vue&type=script&lang=js&"
import style0 from "./wx-mixed.vue?vue&type=style&index=0&id=09f29d59&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f29d59",
  null
  
)

export default component.exports